import {
  Component,
  OnInit,
  ElementRef,
  inject,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SplashScreenService } from './splash-screen.service';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit {
  private splashScreenService = inject(SplashScreenService);

  readonly splashScreen = viewChild<ElementRef>('splashScreen');

  ngOnInit(): void {
    this.splashScreenService.init(this.splashScreen());
  }
}
